module.exports = __webpack_public_path__ + "src/assets/img/guestlist_one_double1.52f4dc60.jpg";